import React from 'react'
import { Table, Tbody, Td, Th, Thead, Tr } from '@/shared/ui/Table'
import type { FinanceMonthlyTimeseriesRow } from '../services/financeReportsService'
import { formatMonthLabel } from '../utils/month'
import { formatMoneyFromCents } from '../utils/money'

type Props = {
  rows: FinanceMonthlyTimeseriesRow[]
}

export function FinanceTimeseriesTable({ rows }: Props) {
  if (!rows.length) {
    return <div className="text-sm text-foreground/70">Sem dados para a série.</div>
  }

  return (
    <div className="rounded-2xl border border-slate-800/80 bg-slate-950/80 p-4">
      <div className="mb-3 text-sm font-medium">Série mensal (últimos meses)</div>
      <div className="overflow-auto">
        <Table>
          <Thead>
            <Tr>
              <Th>Mês</Th>
              <Th className="text-right">Ativos (pagantes)</Th>
              <Th className="text-right">Receita líquida</Th>
              <Th className="text-right">Custos fixos</Th>
              <Th className="text-right">Custos avulsos</Th>
              <Th className="text-right">Payouts (afiliados)</Th>
              <Th className="text-right">Resultado</Th>
            </Tr>
          </Thead>
          <Tbody>
            {rows.map((r) => (
              <Tr key={r.month}>
                <Td className="font-medium">{formatMonthLabel(r.month)}</Td>
                <Td className="text-right">{Number(r.active_paying_accounts_count || 0).toLocaleString('pt-BR')}</Td>
                <Td className="text-right">{formatMoneyFromCents(r.revenue_net_cents, 'BRL')}</Td>
                <Td className="text-right">{formatMoneyFromCents(r.fixed_costs_cents, 'BRL')}</Td>
                <Td className="text-right">{formatMoneyFromCents(r.variable_costs_cents, 'BRL')}</Td>
                <Td className="text-right">
                  {formatMoneyFromCents((r.affiliate_payouts_paid_cents || 0) + (r.affiliate_payouts_fee_cents || 0), 'BRL')}
                </Td>
                <Td className="text-right font-semibold">
                  {formatMoneyFromCents(r.net_result_cents, 'BRL')}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </div>
    </div>
  )
}

